<ht-table
  #userTable
  [data]="filteredUsers"
  [(selectedIds)]="selectedUsersIds"
  [disabledIds]="disabledUserIds"
  [config]="configTable"
></ht-table>
@if (filteredUsers?.length === 0 && users?.length > 0) {
  <div role="empty-case-filter" class="text-body-small">{{
    emptyCaseFilterText || emptyCaseFilterFallback
  }}</div>
}
@if (filteredUsers?.length === 0 && users?.length === 0) {
  <div role="empty-case-list" class="text-body-small">{{
    emptyCaseListText || emptyCaseListFallback
  }}</div>
}
